<!-- ===== El botón de subir el Excel de RH =====
     Antes de guardar nada se enseña la vista previa, fila por fila, para
     poder cancelar sin dejar rastro. -->

<!-- En la barra de Configuración del Calendario. Un <button> que abre el
     <input type=file> oculto, igual que el de la barra: antes era un
     <label> que envolvía al input, y un <label> no se alcanza con Tab. -->
<ng-container *ngIf="estilo !== 'barra'">
  <input #archivoPlano type="file" hidden aria-label="Subir Excel de RH" accept=".xlsx"
         (change)="eligeExcelRh($event)" [disabled]="leyendoExcel" />
  <button type="button" class="vac-btn vac-btn--plano vac-subir"
          [disabled]="leyendoExcel"
          (click)="archivoPlano.click()"
          matTooltip="Carga la hoja de RH: cada quien queda en su periodo de aniversario, con sus gozados y lo acumulado"
          matTooltipClass="vac-tip">
    <span class="material-icons">
      {{ leyendoExcel ? 'hourglass_top' : 'upload_file' }}
    </span>
    {{ leyendoExcel ? 'Leyendo…' : 'Subir Excel de RH' }}
  </button>
</ng-container>

<!-- En la barra de una pantalla table-page (Seguimiento RH): el mismo
     botón secundario que su «Hoy» y sus «Exportar». Un mat-raised-button
     no puede envolver al input, así que el input va aparte y el botón lo
     abre. -->
<ng-container *ngIf="estilo === 'barra'">
  <input #archivoRh type="file" hidden aria-label="Subir Excel de RH" accept=".xlsx"
         (change)="eligeExcelRh($event)" [disabled]="leyendoExcel" />
  <button type="button" mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary vac-subir-barra"
          [disabled]="leyendoExcel"
          (click)="archivoRh.click()"
          matTooltip="Carga la hoja de RH de un área: cada quien queda en su periodo de aniversario, con sus gozados y lo acumulado"
          matTooltipClass="vac-tip">
    <span class="material-icons">{{ leyendoExcel ? 'hourglass_top' : 'upload_file' }}</span>
    {{ leyendoExcel ? 'Leyendo…' : 'Subir Excel de RH' }}
  </button>
</ng-container>

<!-- ===== Vista previa de la carga del Excel de RH =====
     Todavía no se ha escrito nada: esto es lo que se HARÍA. Se usan
     vac-overlay y vac-modal para que se vea igual que el modal de días
     del Calendario y para que los temas Oscuro y Cristal lo tomen sin CSS
     nuevo. -->
<div class="vac-overlay vac-overlay--alto" *ngIf="planImportacion"
     (click)="insisteEnCerrar()" (keydown.enter)="insisteEnCerrar()"></div>
<!-- Un diálogo de verdad para el teclado y el lector de pantalla: Tab da la
     vuelta adentro (cdkTrapFocus), el foco entra al abrir y regresa al botón
     de subir al cerrar (AutoCapture), y Escape cierra como la ✕. -->
<div class="vac-modal vac-modal--ancho" [class.is-tiron]="tiron" *ngIf="planImportacion"
     role="dialog" aria-modal="true" [attr.aria-labelledby]="idTitulo"
     cdkTrapFocus cdkTrapFocusAutoCapture
     (keydown.escape)="alEscape($event)">
  <div class="vac-modal__cab">
    <h3 [id]="idTitulo">
      <span class="material-icons" aria-hidden="true">upload_file</span>
      Esto es lo que trae el Excel
    </h3>
    <button type="button" class="vac-panel__cerrar" (click)="cerrarPrevia()"
            [disabled]="importando" aria-label="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="vac-modal__cuerpo">
    <div class="vac-imp__cab">
      <span class="vac-imp__archivo">
        <span class="material-icons">description</span>{{ nombreExcel }}
      </span>

      <!-- La hoja del libro, cuando trae más de una con la tabla. Cambiarla
           vuelve a leer el archivo con ella; la carga manda la de la previa. -->
      <label class="vac-imp__hoja" *ngIf="hayVariasHojas && !eligiendoHoja">
        <span class="vac-imp__hoja-et">Hoja</span>
        <!-- La flecha va aparte, como en el filtro de área de Configuración:
             el CSS global le quita la suya a todo <select>. -->
        <span class="vac-imp__hoja-caja">
          <select class="vac-imp__hoja-ctrl" name="hojaExcel"
                  [ngModel]="hojaElegida"
                  (ngModelChange)="cambiaHoja($event)"
                  [disabled]="importando"
                  aria-label="Hoja del libro que se carga">
            <option *ngFor="let h of planImportacion.hojas" [value]="h">{{ h }}</option>
          </select>
          <span class="material-icons vac-imp__hoja-flecha" aria-hidden="true">expand_more</span>
        </span>
      </label>

      <span class="vac-imp__chip"
            [class.es-ok]="planImportacion.valido"
            [class.es-mal]="!planImportacion.valido && !eligiendoHoja"
            [class.es-elige]="eligiendoHoja">
        {{ eligiendoHoja ? 'Falta elegir la hoja'
          : (planImportacion.valido ? 'Listo para cargar' : 'Hay que corregir el archivo') }}
      </span>
      <!-- Cuántas filas y qué les pasa: "38 filas leídas · 3 nuevas · 30
           se actualizan · 5 omitidas · 8 avisos". Los avisos se cuentan
           aquí porque su bloque tiene tope de alto y no se ven todos. -->
      <span class="vac-imp__meta" *ngIf="!eligiendoHoja">
        <b>{{ (planImportacion.filas || []).length }}</b>
        {{ (planImportacion.filas || []).length === 1 ? 'fila leída' : 'filas leídas' }}<ng-container
          *ngFor="let e of conteoEstados"> · {{ e.texto }}</ng-container><ng-container
          *ngIf="(planImportacion.avisos || []).length as n"> · <span class="vac-imp__meta-avisos">{{ n }}
          {{ n === 1 ? 'aviso' : 'avisos' }}</span></ng-container>
      </span>
    </div>

    <!-- El libro trae varias hojas con la tabla (una por área, por ejemplo)
         y no se dijo cuál: se carga UNA a la vez. Es lo único que hay que
         hacer, así que va en grande y en lugar de la fecha. -->
    <div class="vac-imp__elige" *ngIf="eligiendoHoja">
      <span class="material-icons vac-imp__elige-icono">tab</span>
      <div class="vac-imp__elige-texto">
        <b>Este libro trae {{ (planImportacion.hojas || []).length }} hojas con la tabla de vacaciones.</b>
        <span>Elige cuál cargar. Las demás se suben después con el mismo archivo, una por una.</span>
      </div>
      <label class="vac-imp__hoja vac-imp__hoja--grande">
        <span class="vac-imp__hoja-et">Hoja</span>
        <span class="vac-imp__hoja-caja">
          <select class="vac-imp__hoja-ctrl" name="hojaElige"
                  [ngModel]="hojaElegida"
                  (ngModelChange)="cambiaHoja($event)"
                  [disabled]="importando"
                  aria-label="Hoja del libro que se carga">
            <option value="" disabled>Elige una hoja…</option>
            <option *ngFor="let h of planImportacion.hojas" [value]="h">{{ h }}</option>
          </select>
          <span class="material-icons vac-imp__hoja-flecha" aria-hidden="true">expand_more</span>
        </span>
      </label>
      <span class="vac-imp__fecha-nota" *ngIf="leyendoExcel">
        <span class="material-icons">hourglass_top</span>
        Leyendo la hoja «{{ hojaElegida }}»…
      </span>
    </div>

    <!-- La FECHA DE LA HOJA: el día al que RH la cuadró. Cada persona cae
         en el periodo de aniversario que tenía ese día, y lo que COS tenga
         con fecha hasta ese día no se descuenta dos veces. Arranca con la
         del libro; si se cambia, se vuelve a leer la hoja con ella. -->
    <div class="vac-imp__fecha" *ngIf="!eligiendoHoja">
      <label class="vac-imp__fecha-campo">
        <span class="vac-imp__fecha-et">Fecha de la hoja</span>
        <input type="date" class="vac-imp__fecha-ctrl" name="fechaHoja"
               [max]="hoyIso"
               [ngModel]="fechaHoja"
               (ngModelChange)="cambiaFechaHoja($event)"
               [disabled]="importando" />
      </label>
      <span class="vac-imp__fecha-nota" *ngIf="leyendoExcel">
        <span class="material-icons">hourglass_top</span>
        Leyendo la hoja<ng-container *ngIf="hayVariasHojas"> «{{ hojaElegida }}»</ng-container>
        al {{ fechaCompleta(fechaHoja) }}…
      </span>
      <span class="vac-imp__fecha-nota" *ngIf="!leyendoExcel">
        El día al que RH cuadró la hoja: cada quien queda en el periodo que tenía ese día.
        <ng-container *ngIf="planImportacion.fechaExcel">
          El archivo se guardó el {{ fechaCompleta(planImportacion.fechaExcel) }}.
        </ng-container>
        <b *ngIf="fechaHojaPendiente && planImportacion.fechaCorte">
          Lo de abajo sigue al {{ fechaCompleta(planImportacion.fechaCorte) }}.
        </b>
      </span>
    </div>

    <!-- Errores y avisos en un solo bloque con tope de alto y su propia
         rueda: con los de otras áreas llegan ocho o más, y sueltos se
         comían el alto del modal y la tabla no se veía. -->
    <div class="vac-imp__msgs"
         *ngIf="(!eligiendoHoja && (planImportacion.errores || []).length) || (planImportacion.avisos || []).length">
      <!-- Errores: bloquean la carga. Mientras se elige la hoja el único que
           hay es "elija cuál cargar", y eso ya lo dice el recuadro de arriba. -->
      <ng-container *ngIf="!eligiendoHoja">
        <div class="vac-imp__msg es-error" *ngFor="let e of planImportacion.errores">
          <span class="material-icons" aria-hidden="true">error_outline</span><span>{{ e }}</span>
        </div>
      </ng-container>
      <!-- Avisos: no bloquean, pero hay que verlos antes de confirmar. -->
      <div class="vac-imp__msg es-aviso" *ngFor="let a of planImportacion.avisos">
        <span class="material-icons" aria-hidden="true">info_outline</span><span>{{ a }}</span>
      </div>
    </div>

    <!-- Elegir qué se carga.
         El archivo de 2026 se llama "DESARROLLO" y trae nueve áreas, así
         que casi nunca se quiere cargar entero. La columna "Área" del
         Excel no alcanza para separarlo —hay filas que dicen "LÍDERES" y
         filas en blanco que igual son del equipo—, de modo que se elige
         POR FILA y las pastillas de área sólo son un atajo que SUMA.
         Las filas ocultas en el Excel no se marcan solas: van a mano. -->
    <div class="vac-imp__sel" *ngIf="totalCargables">
      <span class="vac-imp__sel-cuenta">
        <b>{{ filasACargar }}</b> de {{ totalCargables }} seleccionadas<ng-container
          *ngIf="ocultasSinMarcar"> · {{ ocultasSinMarcar }}
          {{ ocultasSinMarcar === 1 ? 'oculta' : 'ocultas' }} en el Excel sin marcar</ng-container>
      </span>

      <button type="button" class="vac-imp__sel-btn" (click)="seleccionaTodas()"
              [disabled]="importando || todasMarcadas">
        Todas
      </button>
      <button type="button" class="vac-imp__sel-btn" (click)="seleccionaNinguna()"
              [disabled]="importando || !filasACargar">
        Ninguna
      </button>

      <span class="vac-imp__sel-areas">
        <span class="vac-imp__area-grupo" *ngFor="let a of areasDelPlan()">
          <button type="button" class="vac-imp__area-btn"
                  (click)="seleccionaArea(a.clave)"
                  [disabled]="importando || !a.cargables"
                  [attr.aria-label]="'Agregar ' + a.etiqueta + ' a la selección'"
                  [matTooltip]="'Suma las ' + a.cargables + ' filas de ' + a.etiqueta + ' a lo ya marcado (sin las ocultas en el Excel)'">
            <span class="vac-imp__area-et">{{ a.etiqueta }}</span>
            <span class="vac-imp__area-n">{{ a.cargables }}</span>
          </button>
          <button type="button" class="vac-imp__area-quita"
                  (click)="quitaArea(a.clave)"
                  [disabled]="importando || !seleccionadasDeArea(a.clave)"
                  [attr.aria-label]="'Quitar ' + a.etiqueta + ' de la selección'"
                  matTooltip="Quitar esta área de la selección">
            <span class="material-icons">close</span>
          </button>
        </span>
      </span>
    </div>

    <!-- La clase termina en "-caja" a propósito: así los temas la
         tratan como caja de contenido en línea y no como caja de modal,
         que le pondría la sombra flotante de un panel dentro de otro. -->
    <div class="vac-tabla-caja vac-imp__tabla-caja" *ngIf="(planImportacion.filas || []).length">
      <!-- Lo del Excel junto a lo de COS, columna por columna como la hoja
           de RH. Lo que COS calcula manda (el periodo sale de la Alta
           IMSS, los días de goce de la ley); lo que la hoja dice distinto
           se enseña debajo, en ámbar, para revisarlo antes de cargar. -->
      <table class="vac-imp__tabla">
        <thead>
          <tr>
            <!-- Marca o desmarca todo. En guion cuando hay selección
                 parcial: así se ve de un vistazo que falta gente. -->
            <th class="c vac-imp__col-sel">
              <input type="checkbox" class="vac-imp__casilla"
                     [checked]="todasMarcadas"
                     [indeterminate]="marcadasAMedias"
                     [disabled]="importando || !totalCargables"
                     (change)="alternaTodas()"
                     aria-label="Seleccionar todas las filas que se pueden cargar" />
            </th>
            <th class="c">Fila</th>
            <th class="vac-imp__col-nombre">Nombre<small>en el Excel → en COS</small></th>
            <th class="c">Periodo<small>de aniversario</small></th>
            <th class="c">Años<small>de antigüedad</small></th>
            <th class="c">Días de goce</th>
            <th class="c">Gozados<small>según la hoja</small></th>
            <th class="c">Pendientes<small>de antes</small></th>
            <th class="c">Restantes</th>
            <th class="c">Acumulados</th>
            <th class="c">Hoy puede pedir<small>antes → después</small></th>
            <th class="c">Estado</th>
            <th class="vac-imp__col-nota">Nota</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let f of planImportacion.filas; trackBy: trackFilaPlan">
          <tr [class.es-omitida]="f.estado === 'OMITIDA'"
              [class.es-elegida]="estaSeleccionada(f.filaExcel)"
              [class.con-cierre]="f.periodoCerrado || asignandoFila === f.filaExcel">
            <!-- Las OMITIDA salen apagadas y sin casilla que palomear:
                 el servidor ya las dejó fuera y su motivo se lee en la
                 columna Nota. -->
            <td class="c vac-imp__col-sel">
              <input type="checkbox" class="vac-imp__casilla"
                     [checked]="estaSeleccionada(f.filaExcel)"
                     [disabled]="importando || !esCargable(f)"
                     (change)="alterna(f.filaExcel)"
                     [attr.aria-label]="rotuloCasilla(f)"
                     [attr.title]="f.estado === 'OMITIDA' ? (f.nota || 'Esta fila no se carga') : null" />
            </td>

            <td class="c vac-imp__fila">{{ f.filaExcel }}</td>

            <!-- El nombre de la hoja, a quién se cruzó en COS y qué tan
                 seguro es el cruce. Si se puede asignar a mano no se apaga
                 aunque hoy se omita: ahí está el botón. -->
            <td [class.es-asignable]="puedeAsignarse(f)">
              <span class="vac-imp__nombre">{{ f.nombreExcel }}</span>
              <small class="vac-imp__area" *ngIf="f.area">{{ f.area }}</small>
              <span class="vac-imp__cos" *ngIf="f.idUsuario != null; else sinCruce">
                → {{ f.nombreCos }}
                <small *ngIf="f.userNom">({{ f.userNom }})</small>
              </span>
              <ng-template #sinCruce>
                <span class="vac-config__falta">→ No se encontró en COS</span>
              </ng-template>
              <span class="vac-imp__marcas">
                <span class="vac-imp__conf"
                      [class.es-exacta]="f.confianza === 'EXACTA'"
                      [class.es-dudosa]="f.confianza === 'APELLIDOS' || f.confianza === 'TOKENS'"
                      [class.es-nadie]="f.confianza === 'SIN_RESOLVER'"
                      [class.es-mano]="f.confianza === 'MANUAL'">
                  {{ etiquetaConfianza(f.confianza) }}
                </span>
                <span class="vac-imp__oculta" *ngIf="f.oculta"
                      matTooltip="RH la escondió en la hoja: no se marca sola. Palomea la casilla si sí va."
                      matTooltipClass="vac-tip">oculta en el Excel</span>
                <!-- Se le cargan los días igual; el perfil no se da desde aquí. -->
                <span class="vac-imp__sinperfil" *ngIf="f.puedePedir === false"
                      matTooltip="No tiene el perfil de solicitud de vacaciones en COS: se le cargan los días, pero no podrá pedirlos hasta que se lo den."
                      matTooltipClass="vac-tip">sin perfil para pedir</span>
              </span>
              <!-- Cuando el nombre no cruzó exacto: decir a mano quién es.
                   Apagado mientras se lee otra hoja (asignarApagado): la
                   tabla aún es la de la anterior. data-fila: ahí regresa
                   el foco al cerrar el panel o al llegar la previa. -->
              <span class="vac-imp__asignar-acciones" *ngIf="puedeAsignarse(f)">
                <button type="button" class="vac-imp__asignar-btn"
                        [attr.data-fila]="f.filaExcel"
                        [class.is-abierto]="asignandoFila === f.filaExcel"
                        [attr.aria-expanded]="asignandoFila === f.filaExcel"
                        [disabled]="asignarApagado"
                        (click)="alternaAsignar(f)">
                  <span class="material-icons" aria-hidden="true">person_search</span>Asignar a…
                </button>
                <button type="button" class="vac-imp__asignar-btn es-quitar"
                        *ngIf="f.confianza === 'MANUAL'"
                        [disabled]="asignarApagado"
                        (click)="quitaAsignacion(f)">
                  Quitar asignación
                </button>
              </span>
            </td>

            <!-- El periodo que calcula COS con la Alta IMSS. Si la hoja
                 trae otro inicio (tecleado de hace un año, p. ej.), se
                 enseña debajo. -->
            <td class="c">
              <ng-container *ngIf="f.periodoInicio && f.periodoFin; else guion">
                <span class="vac-imp__periodo">{{ fechaCompleta(f.periodoInicio) }}</span>
                <span class="vac-imp__periodo">al {{ fechaCompleta(f.periodoFin) }}</span>
              </ng-container>
              <small class="vac-imp__difiere" *ngIf="difiere(f.inicioExcel, f.periodoInicio)">
                Excel: {{ fechaCompleta(f.inicioExcel) }}<ng-container
                  *ngIf="f.finExcel"> al {{ fechaCompleta(f.finExcel) }}</ng-container>
              </small>
              <small class="vac-imp__ley" *ngIf="f.altaImss">
                Alta IMSS {{ fechaCompleta(f.altaImss) }}
              </small>
            </td>

            <td class="c">
              {{ f.antiguedad == null ? '—' : f.antiguedad }}
              <small class="vac-imp__difiere" *ngIf="difiere(f.antiguedadExcel, f.antiguedad)">
                Excel: {{ f.antiguedadExcel }}
              </small>
            </td>

            <!-- Los de ley con esa antigüedad; los de la hoja si dice otra cosa. -->
            <td class="c">
              {{ f.diasPorLey == null ? '—' : f.diasPorLey }}
              <small class="vac-imp__difiere" *ngIf="difiere(f.goceExcel, f.diasPorLey)">
                Excel: {{ f.goceExcel }}
              </small>
            </td>

            <!-- Lo que dice la hoja. Lo que COS ya tiene con fecha hasta la
                 fecha de la hoja no se vuelve a sumar. -->
            <td class="c">
              {{ f.gozadosExcel == null ? '—' : f.gozadosExcel }}
              <small class="vac-imp__ley" *ngIf="f.yaEnCos">{{ f.yaEnCos }} ya en COS</small>
            </td>

            <td class="c">{{ f.arrastre == null ? '—' : f.arrastre }}</td>

            <td class="c">
              <span [class.vac-num--negativo]="f.restantes != null && f.restantes < 0">
                {{ f.restantes == null ? '—' : f.restantes }}
              </span>
              <small class="vac-imp__difiere" *ngIf="difiere(f.restantesExcel, f.restantes)">
                Excel: {{ f.restantesExcel }}
              </small>
            </td>

            <!-- Restantes + pendientes, como la columna «acumulados» de la
                 hoja. Si no coinciden se marca: es la cuenta que hay que
                 cuadrar persona por persona. -->
            <td class="c">
              <b [class.vac-num--negativo]="f.disponibles != null && f.disponibles < 0">
                {{ f.disponibles == null ? '—' : f.disponibles }}
              </b>
              <small class="vac-imp__difiere" *ngIf="difiere(f.acumuladosExcel, f.disponibles)">
                <span class="material-icons">warning_amber</span>Excel: {{ f.acumuladosExcel }}
              </small>
              <small class="vac-imp__negativo" *ngIf="f.disponibles != null && f.disponibles < 0">
                Tomó de más: su siguiente periodo se los descuenta
              </small>
            </td>

            <td class="c">
              <span class="vac-imp__cambio">
                {{ f.disponiblesAntes == null ? '—' : f.disponiblesAntes }}
                <span class="material-icons">east</span>
                <b [class.vac-num--negativo]="f.disponiblesDespues != null && f.disponiblesDespues < 0">
                  {{ f.disponiblesDespues == null ? '—' : f.disponiblesDespues }}
                </b>
              </span>
            </td>

            <td class="c">
              <span class="vac-imp__estado"
                    [class.es-nuevo]="f.estado === 'NUEVO'"
                    [class.es-actualiza]="f.estado === 'ACTUALIZA'"
                    [class.es-igual]="f.estado === 'IGUAL'"
                    [class.es-fuera]="f.estado === 'OMITIDA'">
                {{ etiquetaEstadoFila(f.estado) }}
              </span>
            </td>

            <!-- La nota completa del servidor, recortada a unos renglones;
                 entera en el tooltip. -->
            <td class="vac-imp__col-nota">
              <span class="vac-imp__nota-texto" *ngIf="f.nota"
                    [matTooltip]="f.nota" matTooltipClass="vac-tip">{{ f.nota }}</span>
            </td>
          </tr>

          <!-- Quien cumplió aniversario después de que RH cuadró la hoja:
               lo que le sobró de ese periodo pasa al nuevo como acumulado.
               Va en su propio renglón para que se lea de corrido. -->
          <tr class="vac-imp__cierre" *ngIf="f.periodoCerrado"
              [class.con-cierre]="asignandoFila === f.filaExcel"
              [class.es-omitida]="f.estado === 'OMITIDA'"
              [class.es-elegida]="estaSeleccionada(f.filaExcel)">
            <td class="vac-imp__col-sel"></td>
            <td colspan="12">
              <span class="material-icons">update</span>
              {{ textoCierre(f) }}
            </td>
          </tr>

          <!-- Asignar a mano: primero los parecidos que propone el servidor
               (comparten apellido) y, si no está ahí, buscarlo entre todos
               los activos. Va en un renglón debajo de la fila y no en un
               menú flotante: la tabla rueda dentro de su caja y un menú se
               cortaría en las últimas filas. -->
          <tr class="vac-imp__asignar-fila" *ngIf="asignandoFila === f.filaExcel">
            <td class="vac-imp__col-sel"></td>
            <td colspan="12">
              <div class="vac-imp__asignar">
                <div class="vac-imp__asignar-cab">
                  <span>
                    ¿Quién es <b>{{ f.nombreExcel }}</b> (fila {{ f.filaExcel }}) en COS?
                  </span>
                  <button type="button" class="vac-imp__asignar-cerrar" (click)="cierraAsignar(true)"
                          aria-label="Cerrar sin asignar">
                    <span class="material-icons">close</span>
                  </button>
                </div>

                <div class="vac-imp__asignar-grupo" *ngIf="(f.candidatos || []).length">
                  <span class="vac-imp__asignar-et">Parecidos</span>
                  <button type="button" class="vac-imp__cand"
                          *ngFor="let u of f.candidatos; trackBy: trackUsuario"
                          [class.es-actual]="u.idUsuario === f.idUsuario"
                          [disabled]="asignarApagado || u.idUsuario === f.idUsuario || otraFilaDe(u, f) != null"
                          (click)="asigna(f, u)"
                          [matTooltip]="tipUsuario(u, f)" matTooltipClass="vac-tip">
                    {{ u.nombre }}
                    <small *ngIf="u.userNom">{{ u.userNom }}</small>
                    <small class="vac-imp__cand-otra" *ngIf="otraFilaDe(u, f) != null">fila {{ otraFilaDe(u, f) }}</small>
                  </button>
                </div>

                <ng-container *ngIf="(planImportacion.usuarios || []).length">
                  <label class="vac-imp__buscar">
                    <span class="material-icons">search</span>
                    <input type="text" name="buscaUsuario" autocomplete="off"
                           [ngModel]="busquedaUsuario"
                           (ngModelChange)="buscaUsuario($event)"
                           placeholder="Buscar a alguien más en COS (nombre o usuario)"
                           aria-label="Buscar a alguien en COS" />
                  </label>

                  <div class="vac-imp__asignar-grupo" *ngIf="busquedaUsuario.trim()">
                    <button type="button" class="vac-imp__cand"
                            *ngFor="let u of resultadosUsuario; trackBy: trackUsuario"
                            [class.es-actual]="u.idUsuario === f.idUsuario"
                            [disabled]="asignarApagado || u.idUsuario === f.idUsuario || otraFilaDe(u, f) != null"
                            (click)="asigna(f, u)"
                            [matTooltip]="tipUsuario(u, f)" matTooltipClass="vac-tip">
                      {{ u.nombre }}
                      <small *ngIf="u.userNom">{{ u.userNom }}</small>
                      <small class="vac-imp__cand-otra" *ngIf="otraFilaDe(u, f) != null">fila {{ otraFilaDe(u, f) }}</small>
                    </button>
                    <span class="vac-imp__asignar-nota" *ngIf="masResultados">
                      y {{ masResultados }} más: escribe más del nombre.
                    </span>
                    <span class="vac-imp__asignar-nota" *ngIf="!resultadosUsuario.length">
                      Nadie activo en COS coincide con «{{ busquedaUsuario.trim() }}».
                    </span>
                  </div>
                </ng-container>

                <span class="vac-imp__asignar-nota">
                  Se vuelve a leer la hoja con esta persona. Si ya está en otra fila no se
                  asigna: una persona va en una sola fila.
                </span>
              </div>
            </td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <p class="vac-modal__nota">
      Sólo se carga lo palomeado; el resto del archivo se queda como está y se
      puede cargar después con el mismo Excel. Cada quien queda en el periodo de
      aniversario que tenía a la fecha de la hoja, con los días de ley, lo gozado
      antes de COS y lo pendiente de antes; si cumplió aniversario después, se le
      abre el periodo nuevo con lo que le sobró como acumulado. La carga es
      aditiva: a quien no venga en el Excel no se le toca nada, y ni el área ni
      quién autoriza se cambian con lo que diga la hoja — de eso manda el
      organigrama. Los días que ya están en COS con fecha no se vuelven a contar.
    </p>
  </div>

  <div class="vac-modal__pie">
    <button type="button" class="vac-btn vac-btn--plano" (click)="cerrarPrevia()"
            [disabled]="importando">
      Cancelar
    </button>
    <button type="button" class="vac-btn vac-btn--primario" (click)="cargarExcelRh()"
            [disabled]="!puedeCargarExcel">
      <span class="material-icons">{{ importando ? 'hourglass_top' : 'cloud_upload' }}</span>
      {{ rotuloCargar }}
    </button>
  </div>
</div>

<ng-template #guion><span class="vac-config__falta">—</span></ng-template>
